module.exports = __webpack_public_path__ + "static/img/logo_ssymmetry.6d384fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_ssymmetry.png
// module id = SyZe
// module chunks = 64